import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {messages} from './../translations/translations'


Vue.use(VueI18n);
const initIl8n = (config) => {

  var il8nConfig

  if(!config || !config.il8n) {
    il8nConfig = {
      locale: 'nl',
      fallbackLocale: 'en'
    }
  } else {
    il8nConfig = config.il8n
  }
  return new VueI18n({
    locale: il8nConfig.locale,
    fallbackLocale: il8nConfig.fallbackLocale,
    silentFallbackWarn: true,
    messages
  });
}


export {initIl8n};
